export default __webpack_public_path__ + "static/media/music_marimba_chord_major.4a971825.mp3";